const jQuery = window.jQuery; // eslint-disable-line prefer-destructuring

export default class PostSpoilerCover {
  constructor() {
    this.spoilerTextsExists =
      document.querySelectorAll(".js-post-body-text.is-blurred").length > 0;
    this.$spoilerPostBodies = jQuery(".js-post-body-spoiler");
  }

  init() {
    this.setPointerToSpoilerBodies();
    this.bindEvents();
  }

  bindEvents() {
    this.$spoilerPostBodies.on("click", (event) => {
      const $element = jQuery(event.currentTarget);
      $element.children(".js-post-body-text").toggleClass("is-blurred");
      $element.toggleClass("is-pointer");
    });
  }

  setPointerToSpoilerBodies() {
    if (this.spoilerTextsExists) {
      this.$spoilerPostBodies.addClass("is-pointer");
    }
  }
}
